<template lang="pug">
uc-animate.uc-parallax(
  :parallax="parallax"
  :shouldGrow="true"
  v-bind="$attrs"
  v-for="{ parallax, img } in images"
)
  uc-asset(:class="classAttr" :src="img")
</template>

<script setup lang="ts">
import { computed } from 'vue';
// import createParallax from '../lib/createParallax';
const props = defineProps<{
  classAttr?: string;
  layers: { [parallax: number]: string | UcAsset }[];
}>();

const images = computed(() => {
  return props.layers
    .map(l => Object.entries(l).map(([parallax, img]) => ({ parallax, img })))
    .flat();
});

// watchEffect(() => {
//   if (itemRefs.value.length > 0) {
//     itemRefs.value.forEach(item => {
//       const parallax = +(el.dataset.parallax || 0);
//       createParallax(el, parallax);
//     });
//   }
// });
</script>
